import axios from 'axios';
import { CVAPI, ROLES, USERAPI } from '../const';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Cookie from 'js-cookie';

//
// ─── THUNKS ─────────────────────────────────────────────────────────────────────
//

export const requestLogin = createAsyncThunk('global/common/login', async (args, { getState }) => {
  const resp = await axios
    .post(`${USERAPI}/auth/signin`, {
      cuil: args.cuil,
      password: args.password,
    })
    .catch((error) => {
      if (error.response.status === 422) throw new Error('Usuario o contraseña incorrectos');
      if (error.response.data?.message !== '') throw new Error(error.response.data.message);

      throw new Error('Error al conectarse con el servidor');
    });
  // TODO: ELIMINO COOKIES Y TOKEN BASURA ANTES DE LOGUEAR
  axios.defaults.headers.common['Authorization'] = '';
  Cookie.remove('userConcursar');
  Cookie.set('userConcursar', JSON.stringify(resp.data));
  return resp.data;
});

export const requestLogout = createAsyncThunk(
  'global/common/logout',
  async (args, { getState }) => {
    await (() => new Promise((resolve) => setTimeout(resolve, 1000)))();
    axios.defaults.headers.common['Authorization'] = '';
    Cookie.remove('userConcursar');
    return null;
  },
);

export const fetchPaises = createAsyncThunk('common/fetchPaises', async (args, { getState }) => {
  const loadedPaises = getState().common.paises;
  if (Object.keys(loadedPaises).length > 0) return loadedPaises;

  let data = JSON.parse(localStorage.getItem('concursarPaises'));
  if (data == null) {
    const response = await axios.get(`${CVAPI}/pais`);
    data = response.data.reduce((acu, cur) => {
      acu[cur.idPais] = cur;
      return acu;
    }, {});
    localStorage.setItem('concursarPaises', JSON.stringify(data));
  }

  return data;
});
export const fetchProvincias = createAsyncThunk(
  'common/fetchProvincias',
  async (args, { getState }) => {
    let data = null;

    if (data == null) {
      const response = await axios.get(`${CVAPI}/provincia?pais=13`);
      data = response.data;
      localStorage.setItem('concursarPcias', JSON.stringify(data));
    }
    return data;
  },
);

//
// ─── ACTION MATCHERS ────────────────────────────────────────────────────────────
//
const isRejectedAction = (action) =>
  action.type.startsWith('global/') && action.type.endsWith('rejected');

//
// ─── SLICE ──────────────────────────────────────────────────────────────────────
//
const commonSlice = createSlice({
  name: 'common',
  initialState: {
    errorState: {
      msg: '',
    },
    user: {
      roles: [ROLES.GUEST],
    },
    provincias: [],
    paises: {},
    sexos: [
      {
        key: 'M',
        desc: 'Masculino',
      },
      {
        key: 'F',
        desc: 'Femenino',
      },
    ],
    generos: [
      'Mujer',
      'Varón',
      'Mujer trans',
      'Varón trans',
      'Travesti',
      'Transgénero',
      'Queer',
      'Intersexual',
      'No binarie',
      'Prefiero no decirla (No declara)',
    ],
  },
  reducers: {
    clearErrorMsg: (state) => {
      state.errorState.msg = '';
    },
    checkLoginData: (state, action) => {
      state.user = {
        ...action.payload,
        tokenType: 'Bearer',
      };
      axios.defaults.headers.common[
        'Authorization'
      ] = `${state.user.tokenType} ${state.user.token}`;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaises.fulfilled, (state, action) => {
        state.paises = action.payload;
      })
      .addCase(fetchProvincias.fulfilled, (state, action) => {
        state.provincias = action.payload;
      })
      .addCase(requestLogin.fulfilled, (state, action) => {
        state.user = {
          ...action.payload,
          tokenType: 'Bearer',
        };
        axios.defaults.headers.common[
          'Authorization'
        ] = `${state.user.tokenType} ${state.user.token}`;
      })
      .addCase(requestLogout.fulfilled, (state, action) => {
        state.user = { roles: [ROLES.GUEST] };
      })
      .addMatcher(isRejectedAction, (state, action) => {
        state.errorState.msg = action.payload?.msg || 'Error al intentar conectar con el servidor';
      });
  },
});

export const errorSelector = (state) => state.common.errorState;
export const userSelector = (state) => state.common.user;
export const pciasSelector = (state) => state.common.provincias;
export const paisesSelector = (state) => state.common.paises;
export const sexosSelector = (state) => state.common.sexos;
export const generosSelector = (state) => state.common.generos;

export const { clearErrorMsg, checkLoginData } = commonSlice.actions;
export default commonSlice.reducer;
